import React from 'react';

import { ProjectVersionProvider } from '@qality/common-components/src/lib/ProjectVersionProvider';
import {
  ProjectService,
  SettingsService,
  StorageOfUniqueServices,
} from '@qality/common-service';

import { TestCyclesOverviewPageView } from './TestCyclesOverviewPage.view';

const TestCyclesOverviewPage: React.FC = () => {
  const [initialized, setInitialized] = React.useState(false);
  const [initialProject, setInitialProject] = React.useState(null);

  const fetchProjectByKey = (key: string) => {
    return ProjectService.getProject(key);
  };

  const init = async () => {
    try {
      const urlSearchParams = await StorageOfUniqueServices.get(
        'URLService'
      ).getJiraURLSearchParams();

      const projectKeyParam = urlSearchParams.get('project.key');

      // projectKeyParam can not exist, then we don't want to request for a project
      if (projectKeyParam) {
        const promises = [];
        promises.push(
          SettingsService.getSettingsForProject({
            key: projectKeyParam,
          })
        );
        promises.push(fetchProjectByKey(projectKeyParam));
        const [settings, project] = await Promise.all(promises);

        if (settings.isPluginEnabled) {
          setInitialProject({
            name: project.name,
            key: project.key,
            id: project.id,
          });
        }
      }

      setInitialized(true);
    } catch (e) {
      /** it's OK to move forward even if initial project is not found */
      setInitialized(true);
    }
  };

  React.useEffect(() => {
    if (!initialProject) {
      init();
    } else {
      setInitialized(true);
    }
  });

  if (!initialized) {
    return null;
  }

  return (
    <ProjectVersionProvider>
      <TestCyclesOverviewPageView initialProject={initialProject} />
    </ProjectVersionProvider>
  );
};

export default TestCyclesOverviewPage;
